import { CardsAddEditBaseComponent } from './cards-add-edit-base.component';
import { Component, Inject } from '@angular/core';
import { ApplicationFacade, CardsNgrxFacade, CustomerFacade, RelatedCardFacade } from '@ridango/components';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AppStartupService } from '@ridango/core';
import Env from '@ridango/core/env';
import { MatDialog } from '@angular/material/dialog';

@Component({
    templateUrl: './cards-add-edit-page.component.html',
    styleUrls: ['./cards-add-edit-page.component.scss']
})
export class CardsAddPageComponent extends CardsAddEditBaseComponent {
    constructor(
        applicationFacade: ApplicationFacade,
        router: Router,
        relatedCardFacade: RelatedCardFacade,
        translate: TranslateService,
        appStartupService: AppStartupService,
        @Inject('ENV') public env: Env,
        customerFacade: CustomerFacade,
        cardsFacade: CardsNgrxFacade,
        matDialog: MatDialog
    ) {
        super(
            applicationFacade,
            router,
            relatedCardFacade,
            translate,
            appStartupService,
            env,
            customerFacade,
            cardsFacade,
            matDialog
        );
        this.mode = 'add';
    }
}
